import React from "react";
import type { ResumeEducation } from "lib/redux/types";
import { TemplateNineResumeSection, TemplateNineResumeSectionWithSubsections } from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFDescription, ResumePDFText } from "../ResumePDF/common";
const Education = ({
  heading,
  educations,
  themeColor,
  showBulletPoints,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  educations: ResumeEducation[];
  themeColor: string;
  showBulletPoints: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateNineResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
      {educations.map(
        (
          { school, degree, startDate, endDate, gpa, descriptions = [] },
          idx
        ) => {
          const hideSchoolName =
            idx > 0 && school === educations[idx - 1].school;
          const showDescriptions = descriptions?.join() !== "";
          return (
            <View key={idx} wrap={false}>
              <View
                style={{
                  ...styles.flexRowBetween,
                  marginTop: hideSchoolName
                    ? "-" + spacing["1"]
                    : spacing["1.5"],
                }}
              >
                <ResumePDFText bold={true}>
                  {gpa ? `${degree} - ${gpa}` : degree}
                </ResumePDFText>
                <ResumePDFText>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              {!hideSchoolName && (
                <ResumePDFText italic={true}>{school}</ResumePDFText>
              )}
              {showDescriptions && (
                <View style={{ ...styles.flexCol, marginTop: spacing["1.5"] }}>
                  <ResumePDFDescription items={descriptions} 
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="education"
                  itemIndex={idx}
                  />
                </View>
              )}
            </View>
          );
        }
      )}
    </TemplateNineResumeSectionWithSubsections>
  );
};

export default Education;
